export default "__VITE_ASSET__MiCl7ydeXBtmiYFVmUSlEA__"